import { css } from "@emotion/react";

import { colors, DeleteCircleIcon } from "@dotnet/telematics-design-system";

import { ClearInputIconProps } from "./types";

export const ClearInputIcon = ({ value, clearValue }: ClearInputIconProps) => {
    const { gray500, textPlaceholder } = colors;

    return value.length > 0 ? (
        <DeleteCircleIcon
            onMouseDown={clearValue}
            css={css({
                color: textPlaceholder,
                cursor: "pointer",
                transition: "color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",

                "&:hover": {
                    color: gray500
                }
            })}
        />
    ) : null;
};
